import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=32dc4d94&scoped=true&"
import script from "./ImageMessage.vue?vue&type=script&lang=js&"
export * from "./ImageMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&id=32dc4d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc4d94",
  null
  
)

export default component.exports